/** Click-to-cycle palette for pending tag chips (LinkDialog / NoteDialog). */
export const INLINE_PALETTE = [
  '#6366F1', // indigo
  '#3B82F6', // blue
  '#0EA5E9', // sky
  '#06B6D4', // cyan
  '#14B8A6', // teal
  '#10B981', // emerald
  '#22C55E', // green
  '#84CC16', // lime
  '#EAB308', // yellow
  '#F59E0B', // amber
  '#F97316', // orange
  '#EF4444', // red
  '#F43F5E', // rose
  '#EC4899', // pink
  '#D946EF', // fuchsia
  '#A855F7', // purple
  '#8B5CF6', // violet
  '#64748B', // slate
  '#78716C', // stone
  '#6B7280', // gray
]
